import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TableDocument from "../../TableDocument";
import { api, get } from "../../../../utils/api";
import FilterModal from "../../../../Components/Common/FilterModal";
import TopMenu from "../../TopMenu";
import { companyId } from "../../../../utils/companyId";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";

const FugitiveEmissionDocuments = () => {
  const { user } = useUser();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState(
    "Refrigeration & Air Conditioning"
  );
  const [url, setUrl] = useState("air");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [columnWidth, setColumnWidth] = useState(
    user?.companyAdmin ? "12% 15% 30% 25% 8%" : "12% 30% 25% 8%"
  );

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: 10,
        facilityList: selectedFacility.join(","),
        company: companyId,
        createdBy: companyId,
      }).toString();

      let apiurl =
        url === "air"
          ? `${api}/scope1/fugitiveEmission/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
          : `${api}/scope1/fireEmission/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`;

      const response = await get(apiurl);
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility]);

  const heading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Emission Source",
      key: "emissionSource",
    },
    {
      title: "Type of Substance",
      key: "typeOfSubstance",
    },
  ].filter(Boolean);

  const fireheading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Emission Source",
      key: "fugitiveEmissionSource",
    },
    {
      title: "Type of Substance",
      key: "typeOfSubstance",
    },
  ].filter(Boolean);

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Origin",
      type: "option",
      key: "origin",
      value: ["filterOrigin"],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: ["filterDestination"],
    },
    {
      title: "Freight Load (Tonnes)",
      type: "limit",
      key: "load",
      value: ["one", "two"],
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
  };

  const toggleData = [
    { title: "Refrigeration & Air Conditioning", url: "air" },
    { title: "Fire Extinguisher", url: "fire" },
  ];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
        <>
          <TopMenu
            {...{
              setDrawerFilterOpen: setIsFilterModalOpen,
              selectedMonth,
              setSelectedMonth,
              selectedYear,
              setSelectedYear,
              selectedOption,
              handleToggle,
              filterApplied: isFiltersApplied,
              toggleData,
              fromDate,
              setFromDate,
              toDate,
              setToDate,
              selectedFacility,
              setSelectedFacility,
            }}
            heading={"Fugitive Emission"}
          />

          <TableDocument
            data={data}
            documnets={["documents"]}
            totalPages={1}
            headers={
              url === "air" ? heading : url === "fire" ? fireheading : ""
            }
            columnWidth={columnWidth}
          />

          <FilterModal
            isOpen={isFilterModalOpen}
            onClose={() => setIsFilterModalOpen(false)}
            filters={filterData}
            onFilterChange={handleFilterChange}
            title="Filter"
          />
        </>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default FugitiveEmissionDocuments;
